import { DialogTitle, DialogContent, Typography } from '@mui/material';
import WrestlerEmailPhoneForm from './WrestlerEmailPhoneForm';

export default function WrestlerInviteStep() {
    return (
        <>
            <DialogTitle>Invite Wrestler?</DialogTitle>
            <DialogContent>
                <Typography sx={{ paddingTop: 1, paddingBottom: 2 }}>
                    Enter the email of the wrestler to invite them to login and manage their profile
                    on BoutPro. <em>(optional)</em>
                </Typography>

                <WrestlerEmailPhoneForm />
            </DialogContent>
        </>
    );
}
